module.exports = __webpack_public_path__ + "img/BG.1756f2d9.svg";